import React, { Component, useState } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { CargasForm } from "./components/CargasForm";
import "./styles/CargasTancada.css";

class CargasTancada extends Component {
    state = {
        idTancada: null,
    };

    componentDidMount() {
        const { match } = this.props;
        const idTancada = match.params.id;
        this.setState({ idTancada });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="produccion_activo"
                    titulo="Tancada"
                    subtitulo="Cargas"
                    col="12"
                >
                    <CargasForm
                        idTancada={this.state.idTancada}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(CargasTancada);
